/**
 * Lädt die zugewiesenen Autorenfarben für den Mandanten eines Beitrags und
 * meldet, wenn sie da sind, damit Karten und Markierungen neu zeichnen.
 */
import { useEffect, useState } from 'react'
import { getAccessToken } from '../auth'
import { CONTENT_API } from '../config'
import { setAssignedColors, subscribeAssignedColors } from '../components/colorFromId'

export function useAuthorColors(postId: number | null | undefined): number {
  const [version, setVersion] = useState(0)

  useEffect(() => subscribeAssignedColors(() => setVersion((v) => v + 1)), [])

  useEffect(() => {
    if (!postId) return
    const token = getAccessToken()
    if (!token) return
    let alive = true
    fetch(`${CONTENT_API}/api/v1/posts/${postId}/author-colors`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : { colors: {} }))
      .then((data) => { if (alive) setAssignedColors(data.colors || {}) })
      .catch(() => { /* ohne Tabelle gelten die Namensfarben */ })
    return () => {
      alive = false
      // Die Tabelle gehört zum Mandanten dieses Beitrags, nicht zum nächsten.
      setAssignedColors({})
    }
  }, [postId])

  return version
}
